import { useState, useEffect } from "react"

export default function AuthLayout({
  children,
  title,
  subtitle,
  logoSrc,
  imageSrc,
  formWidth = "third",
  logoPosition = "top",
  contentPadding = "default",
  maxWidth = "md",
  textAlignment = "left",
}) {
  const [isMobile, setIsMobile] = useState(false)

  // Detect mobile devices
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768)
    }

    checkMobile()
    window.addEventListener("resize", checkMobile)

    return () => {
      window.removeEventListener("resize", checkMobile)
    }
  }, [])

  const formWidthClass = formWidth === "half" ? "lg:w-1/2" : "lg:w-1/3"
  const imageWidthClass = formWidth === "half" ? "lg:w-1/2" : "lg:w-2/3"

  const logoPositionClass =
    logoPosition === "top" ? "mb-4 md:mb-14" : logoPosition === "close" ? "mt-4 md:mt-6 mb-2 md:mb-4" : "mt-4 md:mt-6"

  const contentPaddingClass =
    contentPadding === "small"
      ? "p-4 md:p-6"
      : contentPadding === "large"
        ? "p-6 md:p-10 lg:p-12"
        : "p-5 md:p-8 lg:p-10"

  const maxWidthClass =
    maxWidth === "full"
      ? "w-full"
      : maxWidth === "lg"
        ? "w-full max-w-lg"
        : maxWidth === "xl"
          ? "w-full max-w-xl"
          : "w-full max-w-md"

  const textAlignmentClass = textAlignment === "center" ? "text-center" : ""

  return (
    <div className="flex h-screen w-full p-3 md:p-4 bg-gray-50 overflow-hidden">
      {/* Form Section */}
      <div
        className={`w-full ${formWidthClass} bg-[#5B93FF1A] flex flex-col items-center ${contentPaddingClass} rounded-xl md:rounded-2xl shadow-sm overflow-auto`}
      >
        <div className={`${maxWidthClass} flex flex-col h-full`}>
          {/* Logo */}
          {logoSrc && (
            <div className="flex flex-col items-center">
              <div className={logoPositionClass}>
                <img
                  src={logoSrc || "/placeholder.svg"}
                  alt="OSHIMED Logo"
                  className="w-[120px] h-[140px] md:w-[159px] md:h-[180px]"
                />
              </div>

              {/* OSHIMED title - visible only on mobile */}
              <h2 className="text-xl font-bold mb-6 md:hidden">OSHIMED</h2>
            </div>
          )}

          {/* Title and Subtitle with conditional text alignment */}
          <div className={textAlignmentClass}>
            {title && <h1 className="text-xl md:text-2xl font-semibold mb-3 md:mb-6">{title}</h1>}
            {subtitle && <p className="text-sm md:text-base text-gray-700 mb-6 md:mb-8">{subtitle}</p>}
          </div>

          {/* Form Content (passed as children) */}
          <div className="flex-1 flex flex-col">{children}</div>
        </div>
      </div>

      {/* Image Section - Hidden on mobile */}
      <div className={`hidden lg:block ${imageWidthClass} bg-white relative`}>
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <div className="relative w-64 h-64 md:w-80 md:h-80 lg:w-96 lg:h-96">
            <img
              src={imageSrc || "/placeholder.svg"}
              alt="OSHIMED Image"
              className="w-full h-full rounded-full object-cover"
            />
          </div>
        </div>
      </div>
    </div>
  )
}
